module.exports = __webpack_public_path__ + "img/customers-dd-l3.6517388c.svg";